import React from 'react';

/**
 * SkillEffectDivider — Separador OR entre scenarios de activación.
 *
 * interface-design decisions:
 *  - Color lavanda/púrpura: asociado a Umamusume como color secundario
 *    No es azul (conditions), no es ámbar (preconditions), ocupa su propio espacio.
 *  - Número de scenario grande y en JetBrains Mono: refuerza la densidad analítica.
 *  - Gradiente hacia el centro: línea que "apunta" al badge central.
 *  - Tipografía condensada del "OR": Rajdhani, peso 700.
 *
 * Props:
 *  scenarioNumber: número del escenario que viene DESPUÉS de este divisor
 */
const SkillEffectDivider = ({ scenarioNumber }) => {
    return (
        <div className="flex items-center gap-3 py-2 select-none" aria-hidden="true">
            {/* Línea izquierda con gradiente */}
            <div className="flex-1 h-px bg-gradient-to-r
                from-transparent
                via-purple-200 dark:via-purple-800
                to-purple-300 dark:to-purple-700" />

            {/* Badge central */}
            <div className="flex flex-col items-center gap-0.5 flex-shrink-0">
                {/* OR pill */}
                <span className="px-3 py-0.5 rounded-full text-[10px] font-bold tracking-[0.18em] uppercase
                    bg-purple-100 dark:bg-purple-900/40
                    text-purple-600 dark:text-purple-300
                    border border-purple-200 dark:border-purple-700/70"
                    style={{ fontFamily: "'Rajdhani', sans-serif" }}>
                    OR
                </span>
                {/* Scenario number debajo del OR */}
                <span className="text-[9px] font-semibold tracking-[0.16em] uppercase
                    text-purple-400 dark:text-purple-600"
                    style={{ fontFamily: "'JetBrains Mono', monospace" }}>
                    Scenario {scenarioNumber}
                </span>
            </div>

            {/* Línea derecha con gradiente */}
            <div className="flex-1 h-px bg-gradient-to-l
                from-transparent
                via-purple-200 dark:via-purple-800
                to-purple-300 dark:to-purple-700" />
        </div>
    );
};

export default SkillEffectDivider;
